import type { BaseEntity } from './BaseEntity';
import { Batch } from './Batch';
import { Product } from './Product';

export enum PackagingType {
  BULK = 'BULK',
  JAR = 'JAR',
  POUCH = 'POUCH'
}

export interface ProductInventoryItem extends BaseEntity {
  packagingType: PackagingType;
  productId: number;
  product?: Product | null;
  quantityOnHand?: number | null;
  batchId?: number | null;
  batch?: Batch | null
}

type ValidationResult = { issues: { message: string; path: (keyof ProductInventoryItem)[] }[] };

export function validate(productItem: Partial<ProductInventoryItem>): ValidationResult {
  let issues: ValidationResult['issues'] = [];

  if (!productItem.packagingType) {
    issues = [...issues, { message: 'Packaging type is required', path: ['packagingType'] }];
  }

  return { issues };
}
